<template>
  <div>
    <v-item-group mandatory v-model="selected">
      <v-row>
        <v-col v-for="pricinglists in get_plan_list" :key="pricinglists.id">
          <v-item v-slot="{ active, toggle }">
            <v-card class="mx-auto" max-width="340" @click="toggle">
              <v-card-text :class="active ? 'active' : ''">
                <!-- <span class="popular-plan" v-if="pricinglists['name'] == 'Gold'">MOST POPULAR PLAN</span> -->
                <div class="plan-detailbox">
                  <div class="box-head-content">
                    <h3>{{ pricinglists['name'] }}</h3>
                    <v-img max-height="50" max-width="50" :src="logo_image + pricinglists['icon']"></v-img>
                  </div>
                  <p>{{ pricinglists['description'] }}</p>
                  <h2 v-if="pricinglists['amount'] > pricinglists['discountedPrice']"><span>&#8377;</span> <div class="text-decoration-line-through">{{ pricinglists['amount'] }}</div> {{ pricinglists['discountedPrice'] }} /<span class="light-weight">yr</span></h2>
                  <h2 v-else>
                    <strike style='color:orange'><span class="old_amount"><span>&#8377;</span> {{ pricinglists['old_amount'] }}</span></strike>
                    <span>&#8377;</span> {{ pricinglists['amount'] }} /<span class="light-weight">yr</span></h2>
                  <ul>
                    <li v-for="json_decoded_notes in pricinglists['json_decoded_notes']">{{ json_decoded_notes['note'] }}
                    </li>
                    <span style="margin-top: 25px; font-weight: bold; color: rgb(0, 0, 0); display: block;">*Condition
                      Apply</span>
                  </ul>
                  <div class="choose-box">
                    <button id="rzp-button1" class="btn choose-btn"
                      @click="acceptPrivacyPolicy(pricinglists['old_amount'],pricinglists['amount'], pricinglists['id'], pricinglists['plan_id'], ['period'], pricinglists['currency'], pricinglists['name'])">CHOOSE PLAN</button>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-item>
        </v-col>
        <v-carousel v-model="model" class="mobile-pricing-box">
          <v-carousel-item v-for="pricinglists in get_plan_list" :key="pricinglists.id">
            <v-col>
              <v-item v-slot="{ active, toggle }">
                <v-card class="mx-auto" max-width="340" @click="toggle">
                  <v-card-text :class="active ? 'active' : ''">
                    <!-- <span class="popular-plan" v-if="pricinglists['name'] == 'Gold'">MOST POPULAR PLAN</span> -->
                    <div class="plan-detailbox">
                      <div class="box-head-content">
                        <h3>{{ pricinglists['name'] }}</h3>
                        <v-img max-height="50" max-width="50" :src="logo_image + pricinglists['icon']"></v-img>
                      </div>
                      <p>{{ pricinglists['description'] }}</p>
                      <h2>
                        <strike style='color:orange'><span class="old_amount"><span>&#8377;</span> {{ pricinglists['old_amount'] }}</span></strike>
                        <span>&#8377;</span> {{ pricinglists['amount'] }}/<span class="light-weight">yr</span></h2>
                      <ul>
                        <li v-for="json_decoded_notes in pricinglists['json_decoded_notes']">
                          {{ json_decoded_notes['note'] }}</li>
                        <span
                          style="margin-top: 25px; font-weight: bold; color: rgb(0, 0, 0); display: block;">*Condition
                          Apply</span>
                      </ul>
                      <div class="choose-box">
                        <!-- <p>Read & Accept <a @click="openTermOfServices">Terms & Conditions</a></p> -->
                        <!-- <button id="rzp-button1" class="btn choose-btn" @click="choosePlan(pricinglists['amount'],pricinglists['id'],pricinglists['plan_id'],['period'],pricinglists['currency'],pricinglists['name'])">CHOOSE PLAN</button> -->
                        <button id="rzp-button1" class="btn choose-btn"
                          @click="acceptPrivacyPolicy(pricinglists['old_amount'],pricinglists['amount'], pricinglists['id'], pricinglists['plan_id'], ['period'], pricinglists['currency'], pricinglists['name'])">CHOOSE
                          PLAN</button>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-carousel-item>
        </v-carousel>
      </v-row>
      <div class="pricing-bottom-box">
        <p>Cancel your plan anytime, post {{trial_days}} days trial period. Refer to Subscription <a href="javascript:void(0)"
            @click="dialog1 = !dialog1">Terms & Conditions.</a></p>
        <button class="btn secure-btn" @click="dialog = !dialog">Nimeya is Secure & Private</button>
      </div>
      <div class="text-center ">
        <v-dialog v-model="dialog" width="500">
          <v-card class="secure-modal">
            <v-card-title class="text-h5  ">
              Nimeya is Secure & Private
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialog = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
              <ul style="margin-top:10px;">
                <span>With Nimeya, your information is secure and private.</span>
                <li>We are hosted securely on Amazon’s AWS Cloud</li>
                <li>Information is stored in an end-to-end encrypted form and is SSL secured</li>
                <li>Data is protected using 128/256-bit encryption technology</li>
                <li>2 factor authentication using mobile and email or biometric based access to app</li>
                <li>No data sharing with any third party</li>
                <li>Strong privacy policy</li>
                <li>General Data Protection Regulation (GDPR) compliant</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <div class="text-center">
        <v-dialog v-model="dialog1" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Subscription- Terms & Conditions
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialog1 = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
              <ol style="margin-top:10px;" class="term-condition-list">
                <span>Subscription to the services of Nimeya Technologies Private Limited (Nimeya) are governed by the
                  following terms and conditions. Nimeya is committed to provide its services for the specified period
                  of agreement without any deviation / alternation subject to legal and regulatory guidelines of
                  government authorities. However, the terms may be altered / amended at the sole discretion of Nimeya
                  anytime after the agreement period which will be effective for any renewed period of service. You are
                  advised to read the wordings carefully for your own understanding and may seek expert advice wherever
                  necessary.</span>

                <li>Nimeya offers different types of subscription plans for access to its digital applications through
                  mobile devices and computer / laptops.</li>
                <li>Nimeya reserves the right to alter / amend the features, contents and types of services that it
                  makes available for different subscription plans at any time, including without limitation to
                  registered users. However, services already paid for will continue to be availed with the agreed
                  features and contents during the subscription period.</li>
                <li>By registering on the application / site you can become a registered user.</li>
                <li>As a registered user you will be entitled to use the digital application free of cost for a period
                  of {{trial_days}} days from the date of registration.</li>
                <li>Post the {{trial_days}} days trial period you have to make the subscription payment in accordance with the
                  subscription plan opted by you to continue use the application.</li>
                <li>By submitting payment details, you confirm that you are authorising us to use those payment details
                  for subscription payment.</li>
                <li>The subscription amount will include taxes as applicable by the government.</li>
                <li>The subscription period will be for a period of 1 year post the {{trial_days}} days trial period</li>
                <li>The subscription being non-transferable, cannot be transferred to any other member or to any third
                  party.</li>
                <li>The subscription will be auto renewed at the end of the subscription period on payment of renewal
                  subscription fee at the then prevailing renewal subscription amount.</li>
                <li>You will have the option to port into a higher subscription plan by choosing the appropriate
                  subscription plan option and payment of subscription amount.</li>
                <li>You may also cancel your subscription at any time post free trial period.</li>
                <li>The cancellation will be effective from the next subscription renewal date.</li>
                <li>Subscription once paid is non-refundable.</li>
                <li>The above terms & conditions has to be read in conjunction with the Privacy Policy & Terms of Use.
                </li>
              </ol>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="accept_subscription_privacy_policy_dialogbox" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Subscription- Terms & Conditions
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialog1 = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
              <ol style="margin-top:10px;" class="term-condition-list">
                <span>Subscription to the services of Nimeya Technologies Private Limited (Nimeya) are governed by the
                  following terms and conditions. Nimeya is committed to provide its services for the specified period
                  of agreement without any deviation / alternation subject to legal and regulatory guidelines of
                  government authorities. However, the terms may be altered / amended at the sole discretion of Nimeya
                  anytime after the agreement period which will be effective for any renewed period of service. You are
                  advised to read the wordings carefully for your own understanding and may seek expert advice wherever
                  necessary.</span>

                <li>Nimeya offers different types of subscription plans for access to its digital applications through
                  mobile devices and computer / laptops.</li>
                <li>Nimeya reserves the right to alter / amend the features, contents and types of services that it
                  makes available for different subscription plans at any time, including without limitation to
                  registered users. However, services already paid for will continue to be availed with the agreed
                  features and contents during the subscription period.</li>
                <li>By registering on the application / site you can become a registered user.</li>
                <li>As a registered user you will be entitled to use the digital application free of cost for a period
                  of {{trial_days}} days from the date of registration.</li>
                <li>Post the {{trial_days}} days trial period you have to make the subscription payment in accordance with the
                  subscription plan opted by you to continue use the application.</li>
                <li>By submitting payment details, you confirm that you are authorising us to use those payment details
                  for subscription payment.</li>
                <li>The subscription amount will include taxes as applicable by the government.</li>
                <li>The subscription period will be for a period of 1 year post the {{trial_days}} days trial period</li>
                <li>The subscription being non-transferable, cannot be transferred to any other member or to any third
                  party.</li>
                <li>The subscription will be auto renewed at the end of the subscription period on payment of renewal
                  subscription fee at the then prevailing renewal subscription amount.</li>
                <li>You will have the option to port into a higher subscription plan by choosing the appropriate
                  subscription plan option and payment of subscription amount.</li>
                <li>You may also cancel your subscription at any time post free trial period.</li>
                <li>The cancellation will be effective from the next subscription renewal date.</li>
                <li>Subscription once paid is non-refundable.</li>
                <li>The above terms & conditions has to be read in conjunction with the Privacy Policy & Terms of Use.
                </li>
              </ol>
              <form class="login-form-box register-page pricing-plan_modal-bottombox">
                <v-row class="register-checkbox">
                  <v-checkbox
                    id="checkboxfield"
                    required
                    color="orange"
                    checked="checked"
                    ref="checkboxfield"
                    v-model="checkboxfield"
                    
                    @click="agree($event)"

                  ></v-checkbox>
                    I agree to subscription terms & conditions
                    
                </v-row>
                <span style="color:red !important;" v-if="plan_checkbox_error">Please agree to subscription terms & conditions</span>
                <v-row>
                  <v-col>
                    <v-btn class="blue-btn"
                      @click="openPromoCodeModal" v-if="this.is_first_time == 'yes'">
                      Proceed   
                    </v-btn>
                    <v-btn class="blue-btn"
                      @click="choosePlan" v-else>
                      Proceed   
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="promocode_dialogbox" width="900">
            <v-card class="term-modal" height="300">
              <v-form>
                <v-col><h4>Enter Promocode(If having any promocode)</h4></v-col>
                <v-col>
                    <v-text-field
                        name="promo_code"
                        ref="promo_code" 
                        v-model="promo_code"
                        placeholder="Enter Promo Code"
                        class="promocode_cls"
                        @keydown="onKeyDown"
                    ></v-text-field>
                </v-col>
                <v-col>
                  <p style="color:red" v-if="!is_promocode_valid">{{promocode_validation_message}}</p>
                  <p style="color:green" v-else>{{promocode_validation_message}}</p>
                </v-col>
                <v-col>
                    Note: If you any valid promocode then enter into the above promocode field and click on <b>'Yes'</b> button otherwise click on <b>'No'</b> button.
                </v-col>
                <v-col>
                  <v-row class="buttonbox" >
                    <v-btn class="blue-btn" style="margin-left:14px;" @click="choosePlan()" v-if="!is_promocode_valid">No</v-btn>
                    <v-btn class="blue-border-btn" style="background-color: #D9E6EA !important;" v-else>No</v-btn>
                    <v-btn class="blue-btn" @click="choosePlanWithPromoCode()" v-if="is_promocode_valid">Yes</v-btn>
                    <v-btn class="blue-border-btn" style="background-color: #D9E6EA !important;" v-else>Yes</v-btn>
                  </v-row>
                </v-col>
              </v-form>
           </v-card>   
        </v-dialog>
      </div>
    </v-item-group>
    <modal name="termsandservices"><span> <button type="button" class="close" @click="close" style="float: right;">X&nbsp;&nbsp;&nbsp;&nbsp;
        </button></span><br>This is Term & Conditions</modal>
  </div>
</template>
<script>
import { Auth } from 'aws-amplify';
import Header from '../common/Header.vue';
import JwtService from ".././common/jwt.service";
import { isEmpty } from 'lodash';
import ApiService from '@/api/api.service';
import axios from "axios";

export default {
  components: { Header },
  data: () => ({
    title: [
      "Gold plan is ideal if you intend to use for your self and your family.",
      "Silver plan is ideal if you are currently single and want to use for your self only.",
      "Platinum plan is ideal if you intend to use for your extended family and for family office."
    ],
    get_plan_list: [],
    old_amount: '',
    amount: '',
    selected: 0,
    is_first_time: '',
    plan_status:'',
    remaining_free_days:'',
    dialog: false,
    dialog1: false,
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL,
    delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
    model: 0,
    curr_plan_amt: '',
    curr_plan_old: '',
    curr_plan_server_id: '',
    curr_plan_id: '',
    curr_plan_period: '',
    curr_plan_currency: '',
    curr_plan_name: '',
    accept_subscription_privacy_policy_dialogbox: false,
    checkboxfieldsErrors:'',
    checkboxfield:'',
    plan_agree:false,
    plan_checkbox_error:false,
    promocode_dialogbox:false,
    promo_code:'',
    is_promocode_valid:false,
    promocode_validation_message:'',
    trial_days:'',
    allow_promo_code:''
  }),
  computed: {
    isDataEmpty: function () {
      return isEmpty(this.$store.getters.getProfileDetail.data);
    },
  },
  created() {
    // Fire.$on("picRefresh", () => {
    //   this.appendPlanList();
    // });
    this.appendPlanList();
  },
  mounted() {

    // Fire.$emit("picRefresh");
  },


  
  methods: {
    agree(e){
      if(document.getElementById('checkboxfield').checke == false){
        this.plan_agree = false;    
        this.plan_checkbox_error = true
      }
      else{
        this.plan_checkbox_error = false
        this.plan_agree = true;
      }
    },
    openTermOfServices() {
      this.$modal.show("termsandservices");
    },
    close() {
      this.$modal.hide("termsandservices");
    },
    appendPlanList() {
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      ApiService.setHeader();
      ApiService.post('get-subscription-plan-list', {
        aws_cognito_id: cognito_idp,
        type: 'yearly',
      }).then((response) => {
        this.is_first_time = response.data.is_first_time;
        this.plan_status = response.data.plan_status;
        this.remaining_free_days = response.data.remaining_free_days;
        this.allow_promo_code = response.data.allow_promo_code;
        this.$emit('eventname', this.is_first_time)
        this.$emit('eventPlanStatus', this.plan_status)
        this.$emit('remainingDays', this.remaining_free_days)
        this.get_plan_list = response.data.data;
        this.trial_days = response.data.trial_days;
        this.$emit('trialDays', this.trial_days);
      });
    },
    choosePlan() {
        if(this.plan_agree == false){
          this.plan_checkbox_error = true
        }
        else{
          if (this.is_first_time == 'yes') {
            this.$loading(true)
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            ApiService.setHeader();
            ApiService.post('user-free-plan', {
              aws_cognito_id: cognito_idp,
              plan_id: this.curr_plan_id,
              promo_code:""
            }).then((response) => {
              this.$router.push({ name: "Investometer" }).catch(() => { })
              this.$loading(false)
            })
          }
          else {
            this.$router.push({ name: "ChoosePaymentOptions", params: { plan_id: this.curr_plan_id } }).catch(() => { });
          }
        }
    },

    onKeyDown(evt){
      if (this.promo_code.length >=6) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault()
          return
        }
      }
    },

    

    choosePlanWithPromoCode() {
        
        if(this.promo_code == ''){
          swal.fire({title:"Please enter Promocode"});
        }
        else{
          if (this.is_first_time == 'yes') {
            this.$loading(true)
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            ApiService.setHeader();
            ApiService.post('user-free-plan', {
              aws_cognito_id: cognito_idp,
              plan_id: this.curr_plan_id,
              promo_code:this.promo_code
            }).then((response) => {
              this.$router.push({ name: "Investometer" }).catch(() => { })
              this.$loading(false)
            })
          }
          else {
            this.$router.push({ name: "ChoosePaymentOptions", params: { plan_id: this.curr_plan_id } }).catch(() => { });
          }
        }
    },
    
    openPromoCodeModal(){
      if(document.getElementById('checkboxfield').checked == false){
        this.plan_agree = false;    
        this.plan_checkbox_error = true
      }
      else{
        this.accept_subscription_privacy_policy_dialogbox = false

        if(this.allow_promo_code =='yes'){
          this.promocode_dialogbox = true;
        }
        else{
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          ApiService.setHeader();
          ApiService.post('user-free-plan', {
            aws_cognito_id: cognito_idp,
            plan_id: this.curr_plan_id,
            promo_code:this.promo_code
          }).then((response) => {
            this.$router.push({ name: "Investometer" }).catch(() => { })
            this.$loading(false)
          })
        }
      }
    },
    acceptPrivacyPolicy(old_amount,amount, id, plan_id, period, currency, pricingListName) {
      this.plan_agree = false;
      this.curr_plan_old= old_amount;
      this.curr_plan_amt= amount;
      
      this.curr_plan_server_id= id;
      this.curr_plan_id= plan_id;
      this.curr_plan_period= period;
      this.curr_plan_currency= currency;
      this.curr_plan_name= pricingListName;
      this.accept_subscription_privacy_policy_dialogbox = true;
    }
  },
  
  watch: {
    promo_code(val){
      this.promo_code = val.toUpperCase();
      if(val.length > 6){
        if (val.keyCode >= 48 && val.keyCode <= 90) {
          val.preventDefault()
          return
        }
      }
      let formdata = new FormData();
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      formdata.append("promo_code", val); 
      formdata.append("aws_cognito_id", cognito_idp);
      axios.post( process.env.VUE_APP_ROOT_API+'validate-promocode',
      formdata,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin':'*'
          }
        }
      ).then((response) => {
        if(response.data.status == 'error'){
          this.is_promocode_valid = false
          if(val == ''){
            this.promocode_validation_message = ""
          }
          else{
            this.promocode_validation_message = "Invalid Promocode!"
          }
        }
        else{
            this.is_promocode_valid = true 
            this.promocode_validation_message = "Valid Promocode"
        } 
      }).catch((e) => {}); 
    },
    selected(newValue) {
      const name = this.get_plan_list[this.selected].name
      let index = 0;
      if (name == 'Gold') index = 0;
      else if (name == 'Silver') index = 1;
      else if (name == 'Platinum') index = 2;
      this.$emit('change-selection', this.title[index])
    },
    get_plan_list() {
      let index = 0;
      this.get_plan_list.forEach((element, i) => {
        if (element.name == 'Gold')
          index = i;
      });
      this.selected = index;
    }
  }
}
</script>

<style scoped>
.pricing-plan_modal-bottombox {
    padding: 20px 0px !important;
    text-align: center;
}

.pricing-plan_modal-bottombox .row {
    margin: 0px;
    justify-content: center;
}

.pricing-plan_modal-bottombox .row .col {
    padding: 0px;
    text-align: center;
}

.pricing-plan_modal-bottombox .row .col button {
    margin: 10px 0px 0px !important;
}

.buttonbox {
    display: flex;
    align-items: center;
}

.buttonbox button{
    margin: 0;
    margin-right:15px;
}
.old_amount{
  font-weight:700;
  padding: 0px 10px 0px 0px;
  margin-top:10px;
  color:black;
}
</style>